import { on } from 'delegated-events'
import Vue from 'vue'
import JobApplicationAvailability from '../vue/JobApplicationAvailability'
import JobApplicationLanguages from '../vue/JobApplicationLanguages'

const $form = document.getElementById('JobApplicationForm_JobApplicationForm')
const $fields = document.querySelector('.job-application-additional')
const $postingDropdown = document.querySelector('select[name=JobPosting]')

const state = {
  vm: null
}

const fn = {
  init: () => {
    on('change', 'select[name=JobPosting]', fn.handlePostingChange)

    state.vm = new Vue({
      el: $fields,
      components: {
        'job-application-availability': JobApplicationAvailability,
        'job-application-languages': JobApplicationLanguages
      }
    })

    fn.handlePostingChange()
  },

  handlePostingChange: () => {
    const postingId = $postingDropdown.value

    $.getJSON(`${$form.dataset.controllerUrl}fetchjobpostingdata/${postingId}`)
      .then(resp => {
        state.vm.$children.forEach($component => $component.setPosting(resp))
      })
  }
}

export default {
  can: () => $fields,
  run: fn.init
}
